import React, { useEffect } from "react";
import { FaLinkedin, FaGithub, FaGlobe } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";

const ExperienceModal = ({ isOpen, onClose, experience }) => {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    const preventScroll = (e) => {
      e.preventDefault();
    };

    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.addEventListener("keydown", handleEsc);
      document.addEventListener("touchmove", preventScroll, { passive: false });
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
      document.removeEventListener("keydown", handleEsc);
      document.removeEventListener("touchmove", preventScroll);
    }

    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
      document.removeEventListener("keydown", handleEsc);
      document.removeEventListener("touchmove", preventScroll);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div
        className="relative bg-white rounded-lg shadow-lg p-6 max-w-xs md:max-w-2xl w-full transform transition-transform"
        style={{ maxHeight: "90vh", overflowY: "auto" }}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-900 focus:outline-none"
          aria-label="Close modal"
        >
          <IoMdClose size={24} />
        </button>

        <div>
          <h2 className="text-sm mdl:text-lg text-designColor font-titleFont">
            {experience.duration}
          </h2>
          <h3
            className="py-2 text-sm mdl:text-lg text-designColor font-titleFont font-semibold"
            style={{ textAlign: "justify" }}
          >
            {experience.heading}
          </h3>
          <div style={{ maxHeight: "45vh", overflowY: "auto" }}>
            <h4
              className="text-xs mdl:text-sm font-bodyFont leading-5 md:leading-6 tracking-wide"
              style={{ textAlign: "justify" }}
            >
              {experience.description}
            </h4>
          </div>
          <div className="flex">
            {(experience.linkedinLink ||
              experience.githubLink ||
              experience.sourceLink) && (
              <div className="pt-4 pb-2">
                <p className="font-semibold text-designColor">Explore more:</p>
                <div className="flex space-x-4 mt-4">
                  {experience.linkedinLink && (
                    <a href={experience.linkedinLink} className="exploreIcon">
                      <FaLinkedin />
                    </a>
                  )}
                  {experience.githubLink && (
                    <a href={experience.githubLink} className="exploreIcon">
                      <FaGithub />
                    </a>
                  )}
                  {experience.sourceLink && (
                    <a href={experience.sourceLink} className="exploreIcon">
                      <FaGlobe />
                    </a>
                  )}
                </div>
              </div>
            )}
            <div className="text-right py-2 ml-auto mt-auto">
              <button
                onClick={onClose}
                className="bg-designColor mat-button mat-button-base text-white text-sm py-2 px-4 rounded-lg"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExperienceModal;
